import { useState } from "react";
import { Space, Title, Text, createStyles, Textarea, Alert, Button } from '@mantine/core';
import { beigeColor } from '../../assets/constants';
import FormPaper from '../../components/form-paper/form-paper.component';
import ChangeHistoryVisual from "../../components/change-history-visual/change-history-visual.component";
import { IconAlertCircle } from '@tabler/icons-react';

const useStyles = createStyles((theme) => ({

    outerContainer: {
        background: beigeColor,
        minHeight: '100vh',
        padding: '75px 20px',
        [theme.fn.smallerThan('xs')]: {
            background: 'white',
            padding: '0px',
        }
    },

    formContainer: {
        width: '100%',
        maxWidth: '650px',
        margin: '0px auto',
    },

    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

}));

const KeystrokeHistoryInternal = () => {

    const [questionHistoryTemp, setQuestionHistoryTemp] = useState([]);
    const [questionHistory, setQuestionHistory] = useState([]);
    const [errorLoadingHistory, setErrorLoadingHistory] = useState(null);
    const { classes } = useStyles();

    const updateQuestionHistory = () => {
        try {
            // Parse question history temp
            const questionHistoryParsed = JSON.parse(questionHistoryTemp);
            // Make sure question history is an array
            if (!Array.isArray(questionHistoryParsed)) {
                setErrorLoadingHistory('Question history must be an array');
                return;
            }
            // Make sure every entry of question history is an object
            if (questionHistoryParsed.some(entry => typeof entry !== 'object')) {
                setErrorLoadingHistory('Every entry of question history must be an object');
                return;
            }
            setQuestionHistory([...questionHistoryParsed]);
        } catch (error) {
            console.log("error,", error);  
            setErrorLoadingHistory('Error updating question history');
            return;
        }
    };

    return (
        <div className={classes.outerContainer}>
            <div className={classes.formContainer}>
                <FormPaper>
                    <Title order={3} weight={500}>Text Change Visualizer</Title>
                    <Space h={5} />
                    <Text>
                        This visualizer replays the recorded keystroke history for a recorded open-ended question. It shows the text as it was typed, character by character, and the time taken to type each character.
                    </Text>
                    <Space h='xl' />
                    <Textarea
                        value={questionHistoryTemp}
                        onChange={(event) => setQuestionHistoryTemp(event.target.value)}
                        placeholder='Enter the question history here...'
                    />
                    <Space h='xs' />
                    <Button
                        onClick={updateQuestionHistory}
                    >
                        Update History
                    </Button>
                    <Space h='xl' />
                    {
                        errorLoadingHistory || questionHistory.length === 0
                            ?
                            <Alert
                                icon={<IconAlertCircle size="18px"
                                    stroke='1.75px' />}
                                title="No history"
                                color="red"
                                radius='md'
                            >
                                { errorLoadingHistory || 'Please enter the question history above and click "Update History" to visualize the changes.' }
                            </Alert>
                            :
                            <>
                                <ChangeHistoryVisual
                                    questionHistory={questionHistory}
                                    questionText='N/A'
                                />
                            </>
                    }
                </FormPaper>
            </div>
        </div>
    )
}

export default KeystrokeHistoryInternal;